// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HorizontalBarChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="HorizontalBarChartIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h13v-1.5H4.5z" />
      <path d="M14.004 5.75V4H6v1.75z" />
      <path d="M17 9.624v-1.75H6v1.75z" />
      <path d="M6 13.499v-1.75h7v1.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HorizontalBarChartIcon = /* @__PURE__ */ Object.assign(
  HorizontalBarChartIconComponent,
  { displayName: 'HorizontalBarChartIcon' },
);
